import EventDetailsScene from './EventDetailsScene'
export default EventDetailsScene